import styled from "styled-components";

const StyledRect = styled.rect`
  fill: ${(props) => props.theme.backgroundColor};
`

const Moons = ({num, orbitcolor}) => {
 const moonImages = [
  <g>
    <circle cx="748.84" cy="995.04" r="224.61" fill={orbitcolor} strokeWidth="14px"/>   
    <g>
      <StyledRect x="655.33" y="721.78" width="151.94" height="151.94" />
      <path d="M797.86,731.78V864.32H665.33V731.78H797.86m10-10H655.33V874.32H807.86V721.78Z"/>
      <path d="M726.84,770.43H709.59v-11.7c13.95,0,18.9-3,22.65-13.2h11.1v105h-16.5Z"/>
    </g>
  </g>,

  <g>
    <circle cx="911.02" cy="3274.08" r="130.78" fill={orbitcolor} strokeWidth="14px" />
    <circle cx="1325.97" cy="3606.59" r="88.84" fill={orbitcolor} strokeWidth="14px" />
    <circle cx="3559.14" cy="1195.18" r="88.84" fill={orbitcolor} strokeWidth="14px" />
    <g>
      <StyledRect x="703.97" y="3197.81" width="151.94" height="151.94" />
      <path d="M846.5,3207.81v132.54H714V3207.81H846.5m10-10H704v152.54H856.5V3197.81Z"/>
      <path d="M775.48,3246.46H758.23v-11.7c13.95,0,18.9-3,22.65-13.2H792v105h-16.5Z"/>
    </g>
  </g>,

  <g>
    <circle cx="3300.91" cy="951.16" r="88.84" fill={orbitcolor} strokeWidth="14px"/>
      <g>
        <StyledRect x="3140.55" y="806.42" width="151.94" height="151.94" />
        <path d="M3283.09,816.42V949H3150.55V816.42h132.54m10-10H3140.55V959h152.54V806.42Z"/>
        <path d="M3212.07,855.06h-17.25v-11.7c13.95,0,18.9-3,22.65-13.2h11.1v105h-16.5Z"/>
      </g>
  </g>,

  <g>
    <circle cx="1648.31" cy="398.52" r="224.61"  fill={orbitcolor} strokeWidth="14px"/>
      <g>
        <StyledRect x="1796.65" y="322.25" width="151.94" height="151.94" />
        <path d="M1939.19,332.25V464.78H1806.65V332.25h132.54m10-10H1796.65V474.78h152.54V322.25Z"/>
        <path d="M1868.17,370.89h-17.25v-11.7c13.95,0,18.9-3,22.65-13.2h11.1V451h-16.5Z"/>
      </g>
  </g>,

  <g>
    <circle fill={orbitcolor} strokeWidth="14px" cx="527.85" cy="1367.27" r="224.61"/>
    <g>
      <StyledRect x="676.19" y="1291" width="151.94" height="151.94"/>
      <path d="M818.73,1301v132.54H686.19V1301H818.73m10-10H676.19v152.54H828.73V1291Z"/>
      <path d="M747.71,1339.65H730.46V1328c13.95,0,18.9-3,22.65-13.2h11.1v105h-16.5Z"/>
    </g>
  </g>,

  <g>
    <circle fill={orbitcolor} strokeWidth="14px" cx="2983.62" cy="531.04" r="339.73"/>
    <circle fill={orbitcolor} strokeWidth="14px" cx="716.49" cy="745.89" r="158.4"/>
    <g>
      <StyledRect x="3235.33" y="455.07" width="151.94" height="151.94"/>
      <path d="M3377.87,465.07V597.6H3245.33V465.07h132.54m10-10H3235.33V607.6h152.54V455.07Z"/>
      <path d="M3306.85,503.71H3289.6V492c14,0,18.9-3,22.65-13.2h11.1v105h-16.5Z"/>
    </g>
  </g>,

  <g>
    <circle fill={orbitcolor} strokeWidth="14px" cx="527.85" cy="1367.27" r="224.61"/>
    <g>
      <StyledRect x="676.19" y="1291" width="151.94" height="151.94"/>
      <path d="M818.73,1301v132.54H686.19V1301H818.73m10-10H676.19v152.54H828.73V1291Z"/>
      <path d="M747.71,1339.65H730.46V1328c13.95,0,18.9-3,22.65-13.2h11.1v105h-16.5Z"/>
    </g>
  </g>,

  <g>
    <circle fill={orbitcolor} strokeWidth="14px" cx="3428.42" cy="956.65" r="266.92"/>
    <circle fill={orbitcolor} strokeWidth="14px" cx="637.29" cy="825.09" r="79.2"/>
    <circle fill={orbitcolor} strokeWidth="14px" cx="865.09" cy="352.47" r="83.25"/>
    <g>
      <StyledRect x="3607.32" y="953.49" width="151.94" height="151.94"/>
      <path d="M3749.86,963.49V1096H3617.32V963.49h132.54m10-10H3607.32V1106h152.54V953.49Z"/>
      <path d="M3678.84,1002.14h-17.25v-11.7c13.95,0,18.9-3,22.65-13.2h11.1v105h-16.5Z"/>
    </g>
  </g>,

  <g>
    <circle fill={orbitcolor} strokeWidth="14px" cx="3076.18" cy="410.47" r="159.76"/>
    <g>
      <StyledRect x="2844.9" y="334.2" width="151.94" height="151.94"/>
      <path d="M2987.43,344.2V476.73H2854.9V344.2h132.53m10-10H2844.9V486.73h152.53V334.2Z"/>
      <path d="M2916.42,382.84h-17.25v-11.7c13.95,0,18.89-3,22.64-13.2h11.1v105h-16.49Z"/>
    </g>
    <circle fill={orbitcolor} strokeWidth="14px" cx="476.26" cy="1717.77" r="111.23"/>
  </g>,

  <g>
    <circle fill={orbitcolor} strokeWidth="14px" cx="1107.76" cy="3274.58" r="130.78"/>
    <circle fill={orbitcolor} strokeWidth="14px" cx="1601" cy="486.73" r="88.84"/>
    <circle fill={orbitcolor} strokeWidth="14px" cx="3755.88" cy="1195.67" r="88.84"/>
    <g>
      <StyledRect x="900.71" y="3198.31" width="151.94" height="151.94"/>
      <path d="M1043.24,3208.31v132.53H910.71V3208.31h132.53m10-10H900.71v152.53h152.53V3198.31Z"/>
      <path d="M972.22,3247H955v-11.7c13.95,0,18.89-3,22.64-13.2h11.1v105h-16.5Z"/>
    </g>
  </g>,

  <g>
    <circle fill={orbitcolor} strokeWidth="14px" cx="3506.62" cy="2845.62" r="169.55"/>
    <circle fill={orbitcolor} strokeWidth="14px" cx="1652.84" cy="538.58" r="140.68"/>
    <circle fill={orbitcolor} strokeWidth="14px" cx="3692.12" cy="1131.91" r="152.6"/>
    <circle fill={orbitcolor} strokeWidth="14px" cx="523.56" cy="2716.3" r="88.84"/>
    <circle fill={orbitcolor} strokeWidth="14px" cx="2650.55" cy="3453.13" r="60.95"/>
    <g>
      <StyledRect x="3265.93" y="2769.35" width="151.94" height="151.94"/>
      <path d="M3408.46,2779.35v132.53H3275.93V2779.35h132.53m10-10H3265.93v152.53h152.53V2769.35Z"/>
      <path d="M3337.44,2818h-17.25v-11.7c13.95,0,18.9-3,22.65-13.2h11.1v105h-16.5Z"/>
    </g>
  </g>,

  <g>
    <circle fill={orbitcolor} strokeWidth="14px" cx="2730.28" cy="627.46" r="140.68"/>
    <circle fill={orbitcolor} strokeWidth="14px" cx="523.56" cy="2716.3" r="88.84"/>
    <circle fill={orbitcolor} strokeWidth="14px" cx="2650.55" cy="3453.13" r="60.95"/>
    <g>
      <StyledRect x="358.45" y="2563.76" width="151.94" height="151.94"/>
      <path d="M501,2573.76V2706.3H368.45V2573.76H501m10-10H358.45V2716.3H511V2563.76Z"/>
      <path d="M430,2612.41H412.72v-11.7c13.95,0,18.9-3,22.65-13.2h11.1v105H430Z"/>
    </g>
    <circle fill={orbitcolor} strokeWidth="14px" cx="3457.74" cy="2866.09" r="60.95"/>
    <circle fill={orbitcolor} strokeWidth="14px" cx="3396.79" cy="1824.02" r="60.95"/>
    <circle fill={orbitcolor} strokeWidth="14px" cx="3488.22" cy="2400.19" r="30.48"/>
  </g>
]

  const index = num-1
  return (
    moonImages[index]
  )
}

export default Moons
